import { render, staticRenderFns } from "./dry.vue?vue&type=template&id=53cda63d&scoped=true&"
import script from "./dry.vue?vue&type=script&lang=js&"
export * from "./dry.vue?vue&type=script&lang=js&"
import style0 from "./dry.vue?vue&type=style&index=0&id=53cda63d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cda63d",
  null
  
)

export default component.exports